import { SVG_CHECKBOX_LINE, SVG_CHECKBOX_CHECK } from '@getgo/chameleon-icons';
import { Checkbox, checkboxTemplate as template } from '@microsoft/fast-foundation';
import { CheckboxComponent } from './Checkbox';
import styles from './Checkbox.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
import { html } from '@microsoft/fast-element';
export const checkboxDefinition = {
    baseName: 'checkbox',
    baseClass: Checkbox,
    template: template,
    styles: withStylePrefix(styles),
    checkedIndicator: ((element) => {
        const svgTag = element.tagFor('svg');
        return html `<${svgTag} class="checked-indicator">${SVG_CHECKBOX_CHECK}</${svgTag}>`;
    }),
    indeterminateIndicator: ((element) => {
        const svgTag = element.tagFor('svg');
        return html `<${svgTag} class="indeterminate-indicator">${SVG_CHECKBOX_LINE}</${svgTag}>`;
    }),
};
export const chameleonCheckbox = CheckboxComponent.compose(checkboxDefinition);
